import { useCallback } from "react";
import { Formulas, usePhaseActivation } from "./usePhaseActivation";

export interface TeamEnergyState {
	level: number;
	progress: number;
	isTriggered: boolean;
}

export const useTeamEnergy = (
	maxLevel = 5,
	onTriggered?: (team: "A" | "B") => void,
) => {
	const teamA = usePhaseActivation({
		init_level: 0,
		max_level: maxLevel,
		decayFn: Formulas.Linear(0.1),
		on_triggered: () => onTriggered?.("A"),
	});

	const teamB = usePhaseActivation({
		init_level: 0,
		max_level: maxLevel,
		decayFn: Formulas.Linear(0.5),
		on_triggered: () => onTriggered?.("B"),
	});

	const incrementA = useCallback(
		(amount: number) => teamA.incr(amount),
		[teamA],
	);
	const incrementB = useCallback(
		(amount: number) => teamB.incr(amount),
		[teamB],
	);

	const resetA = useCallback(() => teamA.clr(), [teamA]);
	const resetB = useCallback(() => teamB.clr(), [teamB]);

	const resetAll = useCallback(() => {
		teamA.clr();
		teamB.clr();
	}, [teamA, teamB]);

	return {
		teamA: {
			level: teamA.level,
			progress: teamA.progress,
			isTriggered: teamA.isTriggered,
		},
		teamB: {
			level: teamB.level,
			progress: teamB.progress,
			isTriggered: teamB.isTriggered,
		},
		incrementA,
		incrementB,
		resetA,
		resetB,
		resetAll,
	};
};
